<template>
  <div class="preciosV">
    <Menu />
    <Submenu/>

    <h3 class="text-center my-5">Nuestros Precios</h3>

    <section class="pricing py-5">
      <div class="container">
        <div class="row">

          <!-- Free Tier -->
          <div class="col-lg-3">
            <div class="card mb-5 mb-lg-0">
              <div class="card-body">
                <h5 class="card-title text-muted text-uppercase text-center">Prueba 1 dia</h5>
                <h6 class="card-price text-center">$12<span class="period">/month</span></h6>
                <hr>
                <ul class="fa-ul">
                  <li><span class="color-check"><font-icon icon="check-circle"></font-icon></span> Single User</li>
                  <li><span class="color-check"><font-icon icon="check-circle"></font-icon></span> 5GB Storage</li>
                  <li><span class="color-check"><font-icon icon="check-circle"></font-icon></span> Unlimited Public Projects</li>
                  <li><span class="color-check"><font-icon icon="check-circle"></font-icon></span> Community Access</li>
                  <li class="text-muted"><span class="fa-li"><i class="fas fa-times"></i></span> Unlimited Private Projects</li>
                  <li class="text-muted"><span class="fa-li"><i class="fas fa-times"></i></span> Dedicated Phone Support</li>
                  <li class="text-muted"><span class="fa-li"><i class="fas fa-times"></i></span> Free Subdomain</li>
                  <li class="text-muted"><span class="fa-li"><i class="fas fa-times"></i></span> Monthly Status Reports</li>
                </ul>
                <button type='button' class='btn btn-block btn-primary text-uppercase' data-toggle='modal' v-on:click="setPrice(12,'price_1I3MKBHqAl9De6QHOVkBJCF7',4)" data-target='#exampleModal'>Upgrade</button>
              </div>
            </div>
          </div>

          <div class="col-lg-3">
            <div class="card mb-5 mb-lg-0">
              <div class="card-body">
                <h5 class="card-title text-muted text-uppercase text-center">Presonal</h5>
                <h6 class="card-price text-center">$1<span class="period">/month</span></h6>
                <hr>
                <ul class="fa-ul">
                  <li><span class="color-check"><font-icon icon="check-circle"></font-icon></span> Single User</li>
                  <li><span class="color-check"><font-icon icon="check-circle"></font-icon></span> 5GB Storage</li>
                  <li><span class="color-check"><font-icon icon="check-circle"></font-icon></span> Unlimited Public Projects</li>
                  <li><span class="color-check"><font-icon icon="check-circle"></font-icon></span> Community Access</li>
                  <li class="text-muted"><span class="fa-li"><i class="fas fa-times"></i></span> Unlimited Private Projects</li>
                  <li class="text-muted"><span class="fa-li"><i class="fas fa-times"></i></span> Dedicated Phone Support</li>
                  <li class="text-muted"><span class="fa-li"><i class="fas fa-times"></i></span> Free Subdomain</li>
                  <li class="text-muted"><span class="fa-li"><i class="fas fa-times"></i></span> Monthly Status Reports</li>
                </ul>
                <button type='button' class='btn btn-block btn-primary text-uppercase' data-toggle='modal' v-on:click="setPrice(1,'price_1HmiQ5HqAl9De6QHeWXW7UT0',1)" data-target='#exampleModal'>Upgrade</button>
              </div>
            </div>
          </div>

          <!-- Plus Tier -->
          <div class="col-lg-3 equipo1">
            <div class="card mb-5 mb-lg-0">
              <div class="card-body">
                <h5 class="card-title text-muted text-uppercase text-center">Equipo 1</h5>
                <h6 class="card-price text-center">$9<span class="period">/month</span></h6>
                <hr>
                <ul class="fa-ul">
                  <li><span class="color-checkm"><font-icon icon="check-circle"></font-icon></span><strong> 5 Users</strong></li>
                  <li><span class="color-checkm"><font-icon icon="check-circle"></font-icon></span> 50GB Storage</li>
                  <li><span class="color-checkm"><font-icon icon="check-circle"></font-icon></span> Unlimited Public Projects</li>
                  <li><span class="color-checkm"><font-icon icon="check-circle"></font-icon></span> Community Access</li>
                  <li><span class="color-checkm"><font-icon icon="check-circle"></font-icon></span> Unlimited Private Projects</li>
                  <li><span class="color-checkm"><font-icon icon="check-circle"></font-icon></span> Dedicated Phone Support</li>
                  <li><span class="color-checkm"><font-icon icon="check-circle"></font-icon></span> Free Subdomain</li>
                  <li class="text-muted"><span class="fa-li"><i class="fas fa-times"></i></span> Monthly Status Reports</li>
                </ul>
                <button type='button' class='btn btn-block btn-primary text-uppercase' data-toggle='modal' v-on:click="setPrice(9,'price_1HmiRHHqAl9De6QHiJMPHBh6',2)" data-target='#exampleModal'>Upgrade</button>
              </div>
            </div>
          </div>

          <!-- Pro Tier -->
          <div class="col-lg-3">
            <div class="card">
              <div class="card-body">
                <h5 class="card-title text-muted text-uppercase text-center">Equipo 2</h5>
                <h6 class="card-price text-center">$49<span class="period">/month</span></h6>
                <hr>
                <ul class="fa-ul">
                  <li><span class="color-check"><font-icon icon="check-circle"></font-icon></span><strong> Unlimited Users</strong></li>
                  <li><span class="color-check"><font-icon icon="check-circle"></font-icon></span> 150GB Storage</li>
                  <li><span class="color-check"><font-icon icon="check-circle"></font-icon></span> Unlimited Public Projects</li>
                  <li><span class="color-check"><font-icon icon="check-circle"></font-icon></span> Community Access</li>
                  <li><span class="color-check"><font-icon icon="check-circle"></font-icon></span> Unlimited Private Projects</li>
                  <li><span class="color-check"><font-icon icon="check-circle"></font-icon></span> Dedicated Phone Support</li>
                  <li><span class="color-check"><font-icon icon="check-circle"></font-icon></span><strong> Unlimited</strong> Free Subdomains</li>
                  <li><span class="color-check"><font-icon icon="check-circle"></font-icon></span> Monthly Status Reports</li>
                </ul>
                <button type='button' class='btn btn-block btn-primary text-uppercase' data-toggle='modal' v-on:click="setPrice(49,'price_1HmiRhHqAl9De6QHqaQmknlm',3)" data-target='#exampleModal'>
                  Upgrade</button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!--PAYMENT MODAL -->
      <div class='modal fade' id='exampleModal' tabindex='-1' role='dialog' aria-labelledby='exampleModalLabel' aria-hidden='true' data-backdrop='static'>
        <div class='modal-dialog'>
          <div class='modal-content'>
            <div class='modal-header'>
              <h5 class='modal-title' id='exampleModalLabel'>Payment Information</h5>
              <button type='button' class='close' data-dismiss='modal' aria-label='Close'>
                <span aria-hidden='true'>&times;</span>
              </button>
            </div>
            <form >
              <div class='modal-body'>
                <div class="row">
                  <div class="col">
<!--                    <input type="text" class="form-control" placeholder="Card Number">-->
                    <stripe-elements
                      ref="elementsRef"
                      :pk="pk"
                      :amount="amount"
                      @token="tokenCreated"
                      @loading="loading = $event"
                    >
                    </stripe-elements>
                    <div class="form-group form-check ml-2">
                      <input type="checkbox" class="form-check-input" id="exampleCheck1" v-model="confirmar">
                      <label class="form-check-label" for="exampleCheck1">Guardar Tarjeta</label>
                    </div>
                  </div>
                </div>
                <br>
                <!--<div class="row">
                  <div class="col-sm-3">
                    <input type="text" class="form-control" placeholder="Month">
                  </div>
                  <div class="col-sm-3">
                    <input type="text" class="form-control" placeholder="Year">
                  </div>
                  <div class="col-sm-6">
                    <input type="text" class="form-control" placeholder="Security Number">
                  </div>
                </div>-->
              </div>
              <div class='modal-footer'>
                <button @click="submit" class='btn btn-success'>Pay ${{amount/100}}</button>
                <button type='button' class='btn btn-danger' data-dismiss='modal'>Close</button>
              </div>
            </form>
          </div>
        </div>
      </div>

    </section>

  </div>
</template>
<script>
import { mapState } from 'vuex'
import Menu from '@/components/Menu'
import Submenu from '@/components/Submenu'
import {StripeElements  } from 'vue-stripe-checkout';
import $ from 'jquery';
export default {
components:{Menu,Submenu, StripeElements},
data () {
    return {
        pk: localStorage.pk,
        amount:0,
        loading: false,
        token: null,
        charge: null,
        price: '',
        tipo: '',
        confirmar: false
    }
},
methods:{
    setPrice (p,cPrice,tipo){
        this.amount = p * 100;
        this.price = cPrice;
        this.tipo = tipo;
    },
    submit () {
        this.$refs.elementsRef.submit();
    },
    tokenCreated (token) {
        this.token = token;
        // for additional charge objects go to https://stripe.com/docs/api/charges/object
        this.charge = {
            id:localStorage.userID,
            source: token.id,
            currency: 'usd',
            amount: this.amount,
            type: '2',
            price: this.price,
            check: this.confirmar,
            tipo: this.tipo
        }

        this.sendTokenToServer(this.charge);
    },
    sendTokenToServer (charge) {
        this.axios.post(this.url + `update.php`, charge)
            .then(response => {
                //console.log('response:...', response);
                if(response.data.chargeID){
                    alert("Payment Success!")
                    $('#exampleModal').modal('hide');

                    /*let data = {
                      flag: 2,
                      id: localStorage.userID,
                      tipo: this.tipo

                    }
                    this.axios.post(this.url + 'suscripcion.php', data).then(responce => {
                      console.log('suscripcion save', responce);
                    });*/
                    //this.$router.push('/');
                }
            })
            .catch(e => {
                console.log('errors:...', e);
            })
    }
},
computed:{
    ...mapState(['url'])
},
}
</script>


<style lang="">
  @import url('https://fonts.googleapis.com/css2?family=Ubuntu&display=swap');
  .preciosV{
    font-family: 'Ubuntu', sans-serif;
  }
  section.pricing {
    background: #007bff;
    background: linear-gradient(to right, #0062E6, #33AEFF);
  }

  .pricing .card {
    border: none;
    border-radius: 1rem;
    transition: all 0.2s;
    box-shadow: 0 0.5rem 1rem 0 rgba(0, 0, 0, 0.1);
  }

  .pricing hr {
    margin: 1.5rem 0;
  }

  .pricing .card-title {
    margin: 0.5rem 0;
    font-size: 0.9rem;
    letter-spacing: .1rem;
    font-weight: bold;
  }

  .pricing .card-price {
    font-size: 3rem;
    margin: 0;
  }

  .pricing .card-price .period {
    font-size: 0.8rem;
  }

  .pricing ul li {
    margin-bottom: 1rem;
  }

  .pricing .text-muted {
    opacity: 0.7;
  }

  .pricing .btn {
    font-size: 80%;
    border-radius: 5rem;
    letter-spacing: .1rem;
    font-weight: bold;
    padding: 1rem;
    opacity: 0.7;
    transition: all 0.2s;
  }
  .color-check{
    color: #4da3ff;
  }
  .color-checkm{
    color: #00d58c;
  }
  .color-checkbm{
    background-color: #00d58c !important;
    color: #fff !important;
  }
  .color-checkbm:hover{
    color: #fff !important;
  }
  /* Hover Effects on Card */

  @media (min-width: 992px) {
    .pricing .card:hover {
      margin-top: -.25rem;
      margin-bottom: .25rem;
      box-shadow: 0 0.5rem 1rem 0 rgba(0, 0, 0, 0.3);
    }
    .pricing .card:hover .btn {
      opacity: 1;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/Payment/Payment.vue